export default __webpack_public_path__ + "static/media/creditcard.769cef4d.svg";